import React from "react";
import "./Page6.css";
//-----------------------------------------
import { NavLink } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
//-----------------------------------------
import pagePhoto6 from "../images/pagePhoto6.png";
//-----------------------------------------

function Page6() {
  return (
    <div className="page6_container">
      <div className="page6_bangla">
        অর্ডার করার জন্য "Send” এ Click করুন এবং “Order Successful” এই মেসেজ'
        টির জন্য অপেক্ষা করুন।
      </div>
      <div className="page6_english">
        To place an order, click the “Send” button and wait for the “Order
        Successful” message.
      </div>
      <div className="page6_photo_div">
        <img className="page6_photo" src={pagePhoto6} alt="PagePhoto6 Logo" />
      </div>
      {/*--------------go to page-7 (next page) starts-------------*/}
      <NavLink to="/page7" className="goto_next_page" exact>
        <span className="forwardIcon_text">Next</span>
        <ArrowForwardIcon className="next_page_icon" />
      </NavLink>
      {/*--------------go to page-7 (next page) ends-------------*/}
    </div>
  );
}

export default Page6;
